import React from "react";
import { CatalogTableToolbar } from "./CatalogTableToolbar";

export function CatalogTableSurface({ children, ...toolbarProps }) {
  return (
    <section className="catalog-table-surface">
      <CatalogTableToolbar {...toolbarProps} />
      <div className="catalog-table-content">{children}</div>
    </section>
  );
}